import axios, { AxiosError, AxiosRequestConfig } from "axios";
import Swal from "sweetalert2";
import { ApiAuthResponse, ApiResponse } from "../interfaces/interfaces";
import { format, parseISO } from "date-fns";

export function ministryValueToText(ministryValue: string): string {
  const ministries = [{ value: "cgkidz", label: "Kakak Kids" }, { value: "service", label: "Kakak Ibadah" }, { value: "partner", label: "Kakak Partner" }, { value: "dept_support", label: "Departemen Pendukung" }];
  const ministry = ministries.find(o => o.value === ministryValue);
  return ministry?.label ?? "-";
}

export function ministriesValueToText(ministriesValue: string[]): string {
  let temp = []
  for (let value of ministriesValue) {
    temp.push(ministryValueToText(value))
  }
  return temp.join(", ")
}

export function isAdminAuthenticated(): boolean {
  if (sessionStorage.getItem("admin_token")) {
    return true;
  } else {
    return false;
  }
}

export function isUserAuthenticated(): boolean {
  if (sessionStorage.getItem("auth_code")) {
    return true;
  } else {
    return false;
  }
}

export const getBadgeType = (status: string) => {
  switch (status) {
    case "EXPIRED":
    case "CANCELED":
      return "badge-error badge-sm";
    case "WAITING":
      return "badge-warning badge-sm";
    case "PAID":
      return "badge-success badge-sm";
    default:
      return "badge-secondary badge-sm";
  }
};

export function getApiInstance() {
  const controller = new AbortController();
  const payload = {
    baseURL: process.env.GATSBY_API_URL,
    signal: controller.signal,
  } as AxiosRequestConfig<any>;
  const token = sessionStorage.getItem("auth_code");
  if (token) {
    // jika ada token di session
    payload.headers = {
      authorization: "Bearer " + token,
    };
  }
  const instance = axios.create(payload);
  return { instance, controller };
}

export function defaultApiErrorHandler(err: AxiosError) {
  if (err.code !== "ERR_CANCELED") {
    console.error(err.message);
  }
}

export function getAdminApiInstance() {
  const controller = new AbortController();
  const payload = {
    baseURL: process.env.GATSBY_API_URL + "/admin",
    signal: controller.signal,
  } as AxiosRequestConfig<any>;
  const token = sessionStorage.getItem("admin_token");
  if (token) {
    // jika ada token di session
    payload.headers = {
      authorization: "Bearer " + token,
    };
  }
  const instance = axios.create(payload);
  return { instance, controller };
}

export async function login(authCode: string) {
  const { instance } = getApiInstance();
  try {
    const formData = new FormData();
    formData.set("auth_code", authCode);
    const rawResponse = await instance.post("admin/auth", formData);
    const response: ApiResponse<ApiAuthResponse> = rawResponse.data;
    sessionStorage.setItem("admin_token", response.token!);
    localStorage.setItem("person_id", response.result.mygms_id);
    return true;
  } catch (err) {
    console.error("Login failed");
    console.error(err);
    return false;
  }
}

export async function logout() {
  sessionStorage.removeItem("admin_token");
  localStorage.removeItem("person_id");
  window.location.href = "/";
}

export function showLoading() {
  Swal.fire({
    title: "Please Wait",
    showConfirmButton: false,
    allowOutsideClick: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });
}

export const formatDateTime = (val: string) => {
  return format(parseISO(val), "d MMM yyyy HH:mm");
};

// untuk concat string
export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}

export const hasTicketAddon = (ticketId: string) => {
  const ticketsWithAddons = process.env.GATSBY_TICKET_WITH_ADDON?.split(",") ?? []
  return ticketsWithAddons.includes(ticketId)
}

export const hasToolkitLocation = () => {
  return process.env.GATSBY_ENABLE_TOOLKIT_LOCATION === "true"
}

export const hasSizeChart = () => {
  return process.env.GATSBY_ENABLE_SIZECHART === "true"
}